import React, {useCallback, useMemo} from "react";
import {DataTable, DataTableColumnProps, DataTableUrl, OnErrorFn, useNotifications} from "peggirkit";
import {paginationSummaryFormatter} from "@/utils/PaginationUtils";
import {useIntl} from "react-intl";
import {notifyDanger} from "@/utils/NotifyUtils"
import {getEmployeesDataTableColumns} from "@widgets/employees/overview/table/columns/EmployeesDataTableColumns";
import {
    ClockedFilterStatus,
    EmployeeInDataTable,
    employeesDataTableBaseUrl
} from "@widgets/employees/overview/Employees";
import {eatalianoAxios} from "@/data/api/http/axios";


const itemsPerPage = 20;

type Props = {
    dashboardLocation: number,
    statusFilter: ClockedFilterStatus,
};

const EmployeesDataTable = ({dashboardLocation, statusFilter}: Props) => {
    const intl = useIntl();
    const {notify} = useNotifications();
    const dataUrl: DataTableUrl = useCallback(
        () => employeesDataTableBaseUrl(dashboardLocation, statusFilter),
        [dashboardLocation, statusFilter]);
    const columns: DataTableColumnProps<EmployeeInDataTable>[] = useMemo(
        () => getEmployeesDataTableColumns(intl),
        [intl]);
    const onError: OnErrorFn = useCallback(
        () => notifyDanger(intl.formatMessage({id: "operationError"}), notify),
        [intl, notify]);

    return (
        <>
            <DataTable<EmployeeInDataTable>
                label={intl.formatMessage({id: "employees"})}
                url={dataUrl}
                axios={eatalianoAxios}
                paginationOptions={{
                    pageSize: itemsPerPage,
                    pageNumber: 0,
                    scrollToTopOnPageChange: true,
                    currentPageParameter: "page",
                }}
                columnSortingOptions={{
                    sortParameterName: "sort",
                }}
                paginationControl={{
                    navType: {type: "prevNext"},
                    paginationSummaryFormatter: paginationSummaryFormatter(intl),
                    breakpoints: {
                        sm: {navType: {type: "buttons"}},
                    },
                }}
                loadingConfig={{
                    skeletonRepeat: itemsPerPage,
                }}
                rowConfig={{
                    hoverEffect: true,
                }}
                columns={columns}
                size={"compact"}
                onError={onError}
                // toolbar={{
                //     alwaysVisible: true,
                //     bulkActions: {
                //         renderButtonText: n => intl.formatMessage({id: "nItemsSelected"}, {n}),
                //         toggleAllTitle: checked => intl.formatMessage({id: checked ? "deselectAll" : "selectAll"}),
                //         toggleRowTitle: checked => intl.formatMessage({id: checked ? "deselectRow" : "selectRow"}),
                //         actions: [],
                //     },
                // }}
                breakpoints={{md: {size: "normal"}}}
            />
        </>
    );
};

export default EmployeesDataTable;